import { biChart } from '@/api/index'

export function qspGetCountMonitor () {
  return biChart.request({
    method: 'post',
    url: '/QSP_GET_COUNT_MONITOR'
  })
}

export function qsoGetOutDirectMonitor (data) {
  return biChart.request({
    method: 'post',
    url: '/QSP_GET_OUT_DIRECT_MONITOR',
    data
  })
}

export function qspGetWeightMonitor (data) {
  return biChart.request({
    method: 'post',
    url: '/QSP_GET_WEIGHT_MONITOR',
    data
  })
}

export function qspGetOkProcessMonitor (data) {
  return biChart.request({
    method: 'post',
    url: '/QSP_GET_OKPROCESS_MONITOR',
    data
  })
}

export function qspGetChaufferMonitor (data) {
  return biChart.request({
    method: 'post',
    url: '/QSP_GET_CHAUFFER_MONITOR',
    data
  })
}

export function qspGetTurnOverMonitor (data) {
  return biChart.request({
    method: 'post',
    url: '/QSP_GET_TURNOVER_MONITOR',
    data
  })
}
